export default __webpack_public_path__ + "static/media/youtube.2a5d3a68.svg";